// 路由清单集中于此，便于复用与单元测试

// 与 server/common/utils.GenInvitationCode 对齐：2 位非易混淆字母 + 4 位数字，数字首位非 0。
export const INVITE_SHORT_CODE_ROUTE_PATTERN = '[A-HJ-KM-NP-Za-hj-km-np-z]{2}[1-9][0-9]{3}'

const normalizeInviteCodeParam = (value) => {
    const rawValue = Array.isArray(value) ? value[0] : value
    return typeof rawValue === 'string' ? rawValue.toUpperCase() : ''
}

export const routes = [
    // {
    //     path: '/',
    //     component: () => import('@/views/Home.vue')
    // },
    {
        path: '/join',
        component: () => import('@/views/join/index.vue')
    },
    {
        path: '/kol',
        name: 'KOL',
        meta: {
            title: 'Mobius Social'
        },
        component: () => import('@/views/kol/index.vue')
    },
    {
        path: '/sharePost',
        component: () => import('@/views/sharePost/index.vue')
    },
    {
        path: '/invite',
        component: () => import('@/views/invite/index.vue')
    },
    {
        path: '/download',
        component: () => import('@/views/invite/index.vue')
    },
    {
        path: '/landing',
        component: () => import('@/views/landing/index.vue')
    },    
    {
        path: '/futu-auth',
        name: 'FutuAuth',
        meta: {
            title: 'Moomoo OpenD Authorization'
        },
        component: () => import('@/views/futuAuth/index.vue')
    },
    {
        path: '/longbridge-auth',
        name: 'LongbridgeAuth',
        meta: {
            title: 'Longbridge Authorization'
        },
        component: () => import('@/views/longbridgeAuth/index.vue')
    },
    {
        path: '/usmart-auth',
        name: 'USmartAuth',
        meta: {
            title: 'uSMART Authorization'
        },
        component: () => import('@/views/usmartAuth/index.vue')
    },
    {
        path: '/agreement',
        component: () => import('@/views/agreement/index.vue')
    },
    {
        path: '/account-deletion',
        name: 'AccountDeletion',
        meta: {
            titleKey: 'accountDeletion.pageTitle'
        },
        component: () => import('@/views/accountDeletion/index.vue')
    },
    {
        path: '/snapshot',
        name: 'Snapshot',
        meta: {
            title: 'Snapshot'
        },
        component: () => import('@/views/snapshot/index.vue')
    },
    // DOGE活动主页面路由，需在进入前完成Token、语言与设备ID获取
    {
        path: '/campaign',
        name: 'DogeCampaign',
        meta: {
            title: 'DOGE活动',
            requiresAuth: true
        },
        component: () => import('@/views/campaign/index.vue')
    },
    {
        path: '/feature-list',
        name: 'FeatureList',
        meta: {
            title: 'Feature Guide'
        },
        component: () => import('@/views/featureGuide/index.vue')
    },
    {
        path: '/feature-guide',
        name: 'FeatureGuide',
        meta: {
            title: 'Feature Guide'
        },
        component: () => import('@/views/featureGuide/guide.vue')
    },
    {
        path: '/lottery',
        name: 'Lottery',
        meta: {
            title: 'Activity lottery' // 翻译英文  活动抽奖
        },
        component: () => import('@/views/lottery/index.vue')
    },
    {
        path: '/mcoin-guide',
        name: 'McoinGuide',
        meta: {
            title: 'Mobius M Coin 指南',
            titleKey: 'docs.pages.mcoinGuide.title',
            docKey: 'mcoinGuide'
        },
        component: () => import('@/views/docs/index.vue')
    },
    {
        path: '/lottery-rules',
        name: 'LotteryRules',
        meta: {
            title: 'M Coin 转盘抽奖：官方规则与奖品说明',
            titleKey: 'docs.pages.lotteryRules.title',
            docKey: 'lotteryRules',
            fixedColorScheme: 'dark'
        },
        component: () => import('@/views/docs/index.vue')
    },
    {
        path: '/position-snapshot-guide',
        name: 'PositionSnapshotGuide',
        meta: {
            title: '持仓快照说明',
            titleKey: 'docs.pages.positionSnapshotGuide.title',
            docKey: 'positionSnapshotGuide'
        },
        component: () => import('@/views/docs/index.vue')
    },
    {
        path: '/lottery-records',
        name: 'LotteryRecords',
        meta: {
            title: 'Lottery Records'
        },
        component: () => import('@/views/lottery/records.vue')
    },
    {
        path: '/lottery-prizes',
        name: 'LotteryPrizes',
        meta: {
            title: 'My Prizes'
        },
        component: () => import('@/views/lottery/prizes.vue')
    },
    {
        path: '/lottery-prize-detail',
        name: 'LotteryPrizeDetail',
        meta: {
            title: 'Prize Detail'
        },
        component: () => import('@/views/lottery/claim/DetailRedirect.vue')
    },
    {
        path: '/lottery-physical-detail',
        name: 'LotteryPhysicalDetail',
        meta: { title: 'Prize Detail' },
        component: () => import('@/views/lottery/claim/details/PhysicalDetail.vue')
    },
    {
        path: '/lottery-stock-detail',
        name: 'LotteryStockDetail',
        meta: { title: 'Prize Detail' },
        component: () => import('@/views/lottery/claim/details/StockDetail.vue')
    },
    {
        path: '/lottery-crypto-detail',
        name: 'LotteryCryptoDetail',
        meta: { title: 'Prize Detail' },
        component: () => import('@/views/lottery/claim/details/CryptoDetail.vue')
    },
    {
        path: '/lottery-giftcard-detail',
        name: 'LotteryGiftcardDetail',
        meta: { title: 'Prize Detail' },
        component: () => import('@/views/lottery/claim/details/GiftCardDetail.vue')
    },
    {
        path: '/lottery-claim',
        name: 'LotteryClaim',
        meta: {
            title: 'Prize Claim'
        },
        component: () => import('@/views/lottery/claim/ClaimRouter.vue')
    },
    {
        path: '/trade-landing',
        name: 'TradeLanding',
        meta: {
            title: 'Trading'
        },
        component: () => import('@/views/trade/trade-landing.vue')
    },

    // 问题反馈
    {
        path: '/feedback/issue',
        name: 'IssueFeedback',
        meta: {
            title: 'Report Issue',
            requiresAuth: true
        },
        component: () => import('@/views/feedback/issue.vue')
    },
    {
        path: '/feedback/lottery-issue',
        name: 'LotteryIssue',
        meta: {
            title: 'Report Issue',
            requiresAuth: true
        },
        component: () => import('@/views/feedback/lotteryIssue.vue')
    },
    // YouTube 视频直播播放器，供 App 直播详情页上半部分局部 WebView 内嵌使用
    {
        path: '/youtube-live-player',
        name: 'YoutubeLivePlayer',
        meta: {
            title: 'YouTube Live'
        },
        component: () => import('@/views/youtubeLivePlayer/index.vue')
    },

    // 测试与app 交互
    {
        path: '/test',
        component: () => import('@/views/test/index.vue')
    },
    // {
    //     path: '/login',
    //     component: () => import('@/views/login/Index.vue')
    // },
    // {
    //     path: '/wxLogin',
    //     component: () => import('@/views/login/WxLogin.vue')
    // },
    // {
    //     path: '/me',
    //     meta: {
    //         title: '我的'
    //     },
    //     component: () => import('@/views/me/Index.vue')
    // },
    // {
    //     path: '/customize',
    //     component: () => import('@/views/customize/Index.vue')
    // },
    {
        path: `/:inviteCode(${INVITE_SHORT_CODE_ROUTE_PATTERN})`,
        name: 'InviteShortLink',
        redirect: (to) => ({
            path: '/join',
            query: {
                ...to.query,
                code: normalizeInviteCodeParam(to.params.inviteCode)
            }
        })
    },
    
    {
        path: '/',
        redirect: '/download'
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        redirect: '/download'
    },
]

export default routes
